<template>
  <div>
    <v-badge color="white" overlap class="ml-5">
      <template v-slot:badge>
        <span style="color: #000000">{{produtosParaParametrizacao.length}}</span>
      </template>

      <v-btn small color="primary" class="mr-2" @click="dialog = true">
        Parametrização Multipla
      </v-btn>
    </v-badge>

    <v-dialog v-model="dialog" persistent width="550" content-class="bra-20">
      <v-card>
        <v-card-title>
          <v-btn icon @click="fecharDialog" class="ml-n2 mr-4">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <div>
            <p class="ma-0">Parametrização de Múltiplos Produtos</p>
            <p class="ma-0 caption" style="color: #888888">
              {{Helpers.formatarValor(produtosParaParametrizacao.length)}} Produtos selecionados
            </p>
          </div>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-5">
          <p class="ma-0 caption">Selecione os campos para a atualização</p>

          <div class="d-flex ml-n2 pt-2">
            <div>
              <v-checkbox v-model="camposHabilitadosParaEdicao.cobertura_estoque" label="Cobertura de Estoque" />
              <v-checkbox v-model="camposHabilitadosParaEdicao.estoque_max" label="Estoque Máximo" />
            </div>

            <div class="pl-10">
              <v-checkbox v-model="camposHabilitadosParaEdicao.estoque_min" label="Estoque Mínimo" />
              <v-checkbox v-model="camposHabilitadosParaEdicao.multiplo_dist" label="Múltiplo de Distribuição" />
            </div>
          </div>

          <v-divider class="mt-0 mb-5" />

          <text-field-formatador
            :disabled="!camposHabilitadosParaEdicao.cobertura_estoque"
            v-model="produto.cobertura_estoque"
            label="Cobertura de Estoque"
            :max-digitos="4"
            outlined
            remover-valor-irrelevante
            :error-messages="coberturaEstoqueErrors"
            @focus="$event.target.select()"
            @input="$v.produto.cobertura_estoque.$touch()"
            @blur="$v.produto.cobertura_estoque.$touch();setValoresDefault();"
          ></text-field-formatador>

          <div class="d-flex">
            <text-field-formatador
              :disabled="!camposHabilitadosParaEdicao.estoque_min"
              v-model="produto.estoque_min"
              label="Estoque Mínimo"
              :max-digitos="4"
              outlined
              class="mr-2"
              remover-valor-irrelevante
              :error-messages="estoqueMinErrors"
              @input="$v.produto.estoque_min.$touch()"
              @blur="$v.produto.estoque_min.$touch();setValoresDefault();"
              @focus="$event.target.select()"
            ></text-field-formatador>

            <text-field-formatador
              :disabled="!camposHabilitadosParaEdicao.estoque_max"
              v-model="produto.estoque_max"
              label="Estoque Máximo"
              :max-digitos="4"
              outlined
              class="ml-2"
              remover-valor-irrelevante
              :error-messages="estoqueMaxErrors"
              @input="$v.produto.estoque_max.$touch()"
              @blur="$v.produto.estoque_max.$touch();setValoresDefault()"
              @focus="$event.target.select()"
            ></text-field-formatador>
          </div>

          <text-field-formatador
            :disabled="!camposHabilitadosParaEdicao.multiplo_dist"
            v-model="produto.multiplo_dist"
            label="Múltiplo de Distribuição"
            :max-digitos="4"
            outlined
            remover-valor-irrelevante
            :error-messages="multiploDistribuicaoErrors"
            @input="$v.produto.multiplo_dist.$touch()"
            @blur="$v.produto.multiplo_dist.$touch();setValoresDefault();"
            @focus="$event.target.select()"
          ></text-field-formatador>
        </v-card-text>

        <v-card-actions class="mt-n5">
          <v-spacer />

          <v-btn text color="primary" @click="verificaValidacao">salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import textFieldFormatador from "../../utils/TextFieldFormatadorDeValor"
import produtoAPI from "../../../api/produto"
import mixinValidacaoInputs from "./ValidacaoInputsParametrizacao"

export default {
  name: "ParametrizacaoProdutoDialog",
  components: {textFieldFormatador},
  mixins: [mixinValidacaoInputs],
  props: {
    produtosParaParametrizacao: {
      type: Array,
      required: false
    }
  },
  data: () => ({
    dialog: false,
    camposHabilitadosParaEdicao: {cobertura_estoque: true, estoque_min: true, estoque_max: true, multiplo_dist: true},
    produto: {
      cobertura_estoque: 0,
      estoque_min: 0,
      estoque_max: 0,
      multiplo_dist: 1
    }
  }),
  methods: {
    fecharDialog () {
      this.dialog = false
      this.$emit("dialog:close", {})
      this.camposHabilitadosParaEdicao = {cobertura_estoque: true, estoque_min: true, estoque_max: true, multiplo_dist: true}
      this.produto = {cobertura_estoque: 0, estoque_min: 0, estoque_max: 0, multiplo_dist: 1}
    },
    setValoresDefault () {
      ["cobertura_estoque", "estoque_min", "estoque_max"].forEach(key => {
        if (!this.produto[key] && this.produto[key] != 0) {
          this.produto[key] = "0"
        }
      })

      if (!this.produto.multiplo_dist && this.produto.multiplo_dist != 1) {
        this.produto.multiplo_dist = "1"
      }
    },
    verificaValidacao () {
      this.$v.$touch()

      const camposhabilitados = Object.values(this.camposHabilitadosParaEdicao).filter(item => item)

      if (!this.$v.$invalid && camposhabilitados.length > 0) {
        this.validaParametrosDaEdicao()
      }
    },
    validaParametrosDaEdicao () {
      const params = {}

      Object.keys(this.camposHabilitadosParaEdicao).forEach(campo => {
        params[campo] = this.camposHabilitadosParaEdicao[campo] ? this.produto[campo] : undefined
      })

      params.produtos = this.Helpers.arrayColumn(this.produtosParaParametrizacao, ["filial", "idproduto"])

      this.salvarParametrizacaoProdutos(params)
    },
    salvarParametrizacaoProdutos (params) {
      const headers = this.Helpers.iniciarRequisicao()

      this.$store.dispatch("loading/addRequisicao",
        produtoAPI.setParametrizacaoMultiplosProdutos(headers, params)
          .then(response => {
            localStorage.token = response.data.token
            this.fecharDialog()
            this.$emit('atualizado-com-sucesso', {})
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style scoped>
</style>
